import { useQuery } from '@tanstack/react-query';
import { fetchCertificationById } from '@/api/certifications';

export const certificationDetailKeys = {
  detail: (id: string) => ['certifications', 'detail', id] as const,
};

export function useCertificationDetail(id: string) {
  return useQuery({
    queryKey: certificationDetailKeys.detail(id),
    queryFn: () => fetchCertificationById(id),
    staleTime: 60_000,
  });
}
